import type { fetchCommentById } from '@confluence/comments-data-manager/entry-points/useCommentById.ts';

type ReactionsSummary = NonNullable<
	Awaited<ReturnType<typeof fetchCommentById>>
>['reactionsSummary'];

export type RefetchedReaction = {
	commentId: string;
	reactionsSummary: ReactionsSummary;
};

export const getRefetchedReactionSummary = (
	commentId: string | undefined,
	refetchedReaction: RefetchedReaction | null,
): ReactionsSummary | undefined =>
	commentId && refetchedReaction?.commentId === commentId
		? refetchedReaction.reactionsSummary
		: undefined;
